import HomePage from "./home";
import ContactPage from "./contact";
import AboutPage from "./about";
import Create from "./create";
import Accelerate from "./accelerate";

export const CLIENT_ROUTES = [
  {
    Component: HomePage,
    path: "/",
  },
  {
    Component: HomePage,
    path: "/s/:key",
  },
  {
    Component: Create,
    path: "/program-bekup-create",
  },
  {
    Component: Accelerate,
    path: "/program-bekup-accelerate",
  },
  {
    Component: AboutPage,
    path: "/about",
  },
  {
    Component: ContactPage,
    path: "/contact",
  },
  {
    Component: HomePage,
    path: "/*",
  },
];
